module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5wGxz"))).then(() => module.bundle.root('cvs7o'));